var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-loader"},[_c('div',{staticClass:"common-loader__container"},[_c('ui-loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }